import type { EditorTourConfig } from "../types/editor-tour";
import { DEFAULT_EDITOR_TOUR_STORAGE_KEY } from "../types/editor-tour";

export function resolveTourStorageKey(
  storageKey: EditorTourConfig["storageKey"],
): string | null {
  if (storageKey === false) return null;
  return storageKey ?? DEFAULT_EDITOR_TOUR_STORAGE_KEY;
}

function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore quota / private mode */
  }
}

function safeRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Whether the user has dismissed the tour (only when persistence is enabled). */
export function readTourDismissedState(
  tour: EditorTourConfig | undefined,
): boolean {
  if (!tour) return true;
  const key = resolveTourStorageKey(tour.storageKey);
  if (key === null) return false;
  const raw = safeGetItem(key);
  if (raw === null) return false;
  try {
    return JSON.parse(raw) === true;
  } catch {
    return raw === "true";
  }
}

export function writeTourDismissedState(
  tour: EditorTourConfig | undefined,
): void {
  if (!tour) return;
  const key = resolveTourStorageKey(tour.storageKey);
  if (key === null) return;
  safeSetItem(key, JSON.stringify(true));
}

export function clearTourDismissedState(
  tour: EditorTourConfig | undefined,
): void {
  if (!tour) return;
  const key = resolveTourStorageKey(tour.storageKey);
  if (key === null) return;
  safeRemoveItem(key);
}
